import React from 'react';
import Banner from './banner';
import { FormattedMessage } from 'react-intl';
import { LegalConfirm } from '../legal-confirm';
import { Button } from '@dropbox/dig-components/buttons';
import { useHistory } from 'react-router';
import { useSignerAppParams, useSignerContext } from '../signer-experience';
import { useBundleProps } from 'signer-app/bundle-props';
import { useIsMutating } from '@tanstack/react-query';

const ReviewBanner = () => {
  const history = useHistory();
  const { signatureRequestId } = useSignerAppParams();
  const { whiteLabelStyles } = useBundleProps();
  const { finalize } = useSignerContext();
  const isMutating = useIsMutating() > 0;

  function edit() {
    history.push(`/sign/${signatureRequestId}/sign`);
  }

  return (
    <Banner
      title={
        <FormattedMessage
          id="signer.confirm.title"
          description="text in signer flow, informing signer the process of signing the document is almost done"
          defaultMessage="Almost done."
        />
      }
      message={
        <LegalConfirm
          legalVersion={whiteLabelStyles?.legalVersion ?? 'terms1'}
        />
      }
      actions={[
        <Button
          key="i-agree"
          variant="primary"
          size="large"
          onClick={finalize}
          disabled={isMutating}
          // testid for compability with automation
          data-testid="button-next"
        >
          <FormattedMessage
            id="09a523a162632008c5215daf52eec7796499b697cff8169e16ffac5ebb15181a"
            defaultMessage="I agree"
            description="This button completes the signer experience"
          />
        </Button>,
        <Button variant="opacity" size="large" onClick={edit} key="edit">
          <FormattedMessage
            defaultMessage="Edit"
            id="83d20b5fc31227cad45cf12c9bd2242613fa00eab8c8418b707a16e91950ebf1"
            description="Button to edit the document."
          />
        </Button>,
      ]}
    />
  );
};

export default ReviewBanner;
